import { useCallback, useRef } from "react";

export const useLaunchDarklyIdentificationQueue = () => {
  const queueRef = useRef<Promise<void>>(Promise.resolve());

  return useCallback((identifyContext: () => Promise<void>) => {
    const queuedIdentification = queueRef.current.then(
      identifyContext,
      identifyContext
    );
    queueRef.current = queuedIdentification.then(
      () => undefined,
      () => undefined
    );

    return queuedIdentification;
  }, []);
};
